import { Link } from "react-router-dom";
import { Column } from "react-table";
import {
  GetComplianceInvestigationActionsAndInstructionsFetchUrl,
  IComplianceInvestigationActionOrInstruction,
} from "../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import { formatDate } from "../../api/DateUtils";
import { Grid } from "../Grid";
import { ComplianceInvestigationActionsInstructionsGridProps } from "./ComplianceInvestigationActionsInstructionsGridProps";

const ComplianceInvestigationActionsInstructionsGrid = ({
  complianceInvestigationId,
  licenceProfile,
}: ComplianceInvestigationActionsInstructionsGridProps) => {
  const GetUrlForActionOrInstruction = (
    profileNumber: string,
    actionOrInstruction: IComplianceInvestigationActionOrInstruction
  ) => {
    return `/licence-profile/${profileNumber}/compliance/action-or-instruction/${actionOrInstruction.taskid}`;
  };

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetComplianceInvestigationActionsAndInstructionsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(complianceInvestigationId);

  const tableColumnsBig: Column<
    Record<string, IComplianceInvestigationActionOrInstruction>
  >[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForActionOrInstruction(
                  licenceProfile.profileNo,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: false,
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
    {
      Header: "Date Issued by EPA",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IComplianceInvestigationActionOrInstruction>
  >[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForActionOrInstruction(
                  licenceProfile.profileNo,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplianceInvestigationActionsInstructionsGrid };
